import { useEffect, useState } from "react";

import { useSearchParameters } from "@/components/signup/hooks";
import { useUserContext } from "@/components/user-context";
import { DataFoundationsAttributes } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/views/user-seg-bxp-ui/types.ts";
import { DataFoundationsWrapper } from "@/utils/data-foundations/data-foundation-types";

import { getPrimaryProduct } from "../../hooks/utils/use-cloud-status-utils";

import { ControlAnimation } from "./components/control-animation";

export const TwcProvisioningScreen = ({
    provisioningCompleteDefault = false
}: {
    provisioningCompleteDefault?: boolean;
}) => {
    const { products, edition } = useSearchParameters();
    const productKey = getPrimaryProduct(products);
    const { profile } = useUserContext();
    const userType = profile.cohorts?.userType;
    const domainType = profile.cohorts?.domainType;
    const companyType = profile.cohorts?.companyType;
    const [waitForAttributes, setWaitForAttributes] = useState(true);
    const [dataFoundationAttributes, setDataFoundationAttributes] =
        useState<DataFoundationsAttributes>({
            productKey,
            edition
        });

    useEffect(() => {
        if (!profile.requestInProgress) {
            setDataFoundationAttributes((prevAttributes) => ({
                ...prevAttributes,
                userType: userType,
                domainType: domainType,
                companyType: companyType
            }));
            setWaitForAttributes(false);
        }
    }, [profile.requestInProgress, userType, domainType, companyType]);

    return (
        <DataFoundationsWrapper
            dataFoundationsEventOption="ProvisioningScreenViewed"
            attributes={dataFoundationAttributes}
            waitForAttributes={waitForAttributes}
        >
            <ControlAnimation
                provisioningCompleteDefault={provisioningCompleteDefault}
            />
        </DataFoundationsWrapper>
    );
};
